const IG = (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" {...p}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" /></svg>;
const TT = (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}><path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" /></svg>;
const FB = (p) => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}><path d="M13.5 21v-7.5h2.6l.4-3h-3V8.6c0-.9.25-1.5 1.55-1.5h1.6V4.4c-.3-.04-1.25-.12-2.4-.12-2.35 0-3.95 1.43-3.95 4.06v2.16H7.7v3h2.6V21h3.2z" /></svg>;

export const SOCIALS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/deendistrictdrip/", Icon: IG },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@deendistrictdrip", Icon: TT },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/profile.php?id=61595279766787", Icon: FB },
];

const SIZES = { sm: "h-9 w-9", md: "h-11 w-11" };

export const SocialLinks = ({ size = "md", prefix = "footer", className = "" }) => (
  <div data-testid={`${prefix}-socials`} className={`flex items-center gap-3 ${className}`}>
    {SOCIALS.map((s) => (
      <a
        key={s.id}
        href={s.href}
        target="_blank"
        rel="noreferrer"
        aria-label={s.label}
        data-testid={`${prefix}-social-${s.id}`}
        className={`${SIZES[size]} rounded-full border border-[#e3e2dc] flex items-center justify-center text-[#0a0a0b] hover:bg-[#0a0a0b] hover:text-white hover:border-[#0a0a0b] transition-colors duration-300`}
      >
        <s.Icon aria-hidden />
      </a>
    ))}
  </div>
);
